import { z } from 'zod';

export const pricingPlanSchema = z.object({
  service: z.string(),
  username: z.string(),
  user: z.string(),
  token: z.string(),
  host: z.string(),
  org: z.string(),
  repo: z.string().optional(),
  ide: z.string(),
  scheme: z.string(),
  machine: z.string().optional(),
  pat: z.string().optional()
});
